export const Menu = '/Security/GetMenu'
export const GetRoutes = '/Security/GetRoutes'

export const AccountLogin = '/Account/Login'

export const GetAvailableYears = '/Utility/GetAvailableYears'
export const GetReport = '/Utility/GetReport'
export const GetDashboard = '/Utility/GetDashboard'
export const GetReportByName = '/Utility/GetReportByName'
export const RefreshMLModel = '/Utility/TrainModel'
export const ContattaConsulente = '/Utility/ContattaConsulente'

export const StressTestGetList = '/StressTest/GetStressTestList'
export const StressTestGet = '/StressTest/GetStressTest'
export const StressTestSave = '/StressTest/SaveStressTest'
export const StressTestSaveNome = '/StressTest/SaveNomeStressTest'
export const StressTestDelete = '/StressTest/Delete'
export const StressTestGetRettifica = '/StressTest/GetRettifica'
export const StressTestDeleteRettifica = '/StressTest/DeleteRettifica'
export const StressTestSaveRettifica = '/StressTest/SaveRettifica'
export const StressTestExport = '/StressTest/Export'

export const ClienteSearch = '/Cliente/Search'
export const ClienteGetById = '/Cliente/GetById'
export const ClienteGet = '/Cliente/Get'
export const ClienteSave = '/Cliente/Save'
export const GetStatoOperativo = '/Cliente/GetStatoOperativo'

export const UtenteGet = '/Utente/Get'
export const UtenteSave = '/Utente/Save'
export const UtenteSearch = '/Utente/Search'
export const UtenteAssociaCliente = '/Utente/AssociaCliente'
export const UtenteGetClientiAssociati = '/Utente/GetClientiAssociati'

export const UtenteBackofficeGet = '/UtenteBackoffice/Get'
export const UtenteBackofficeSave = '/UtenteBackoffice/Save'
export const UtenteBackofficeSearch = '/UtenteBackoffice/Search'
export const UtenteBackofficeGetClientiAssociati = '/UtenteBackoffice/GetClientiAssociati'
export const UtenteBackofficeAssociaCliente = '/UtenteBackoffice/AssociaCliente'

export const RaccoltaDatiGet =  '/RaccoltaDati/Get'
export const RaccoltaDatiSave = '/RaccoltaDati/Save'
export const RaccoltaDatiGetMovimento = '/RaccoltaDati/GetMovimento'
export const RaccoltaDatiSaveMovimento = '/RaccoltaDati/SaveMovimento'
export const RaccoltaDatiDeleteMovimento = '/RaccoltaDati/DeleteMovimento'
export const RaccoltaDatiSaveSaldo = '/RaccoltaDati/SaveSaldo'
export const RaccoltaDatiImportMovimenti = '/RaccoltaDati/ImportMovimenti'

export const ConfigurazioneGetContiCorrenti = '/Configurazione/GetContiCorrenti'
export const ConfigurazioneSaveContoCorrente = '/Configurazione/SaveContoCorrente'
export const ConfigurazioneEliminaContoCorrente = '/Configurazione/EliminaContoCorrente'
export const ConfigurazioneImportazioneFattureManuale = '/Configurazione/ImportazioneFattureManuale'

export const ConfigurazioneGetCategorie = '/Configurazione/GetCategorie'
export const ConfigurazioneGetCategoria = '/Configurazione/GetCategoria'
export const ConfigurazioneSaveCategoria = '/Configurazione/SaveCategoria'
export const ConfigurazioneEliminaCategoria = '/Configurazione/EliminaCategoria'
export const ConfigurazioneGetConfigurazioneImportFatture = '/Configurazione/GetConfigurazioneImportFatture'
export const ConfigurazioneSaveConfigurazioneImportFatture = '/Configurazione/SaveConfigurazioneImportFatture'
export const ConfigurazioneImportConfigurazioneImportFatture = '/Configurazione/ImportConfigurazioneImportFatture'
export const ConfigurazioneDeleteConfigurazioneImportFatture = '/Configurazione/DeleteConfigurazioneImportFatture'

export const ConfigurazioneGetOpenBankingProvider = '/Configurazione/GetOpenBankingProvider'
export const ConfigurazioneSaveConfigurazioneOpenBanking = '/Configurazione/SaveConfigurazioneOpenBanking'
export const ConfigurazioneImportConfigurazioneOpenBanking = '/Configurazione/ImportConfigurazioneOpenBanking'
export const ConfigurazioneDeleteConfigurazioneOpenBanking = '/Configurazione/DeleteConfigurazioneOpenBanking'
export const YapilyStartAuthFlow = '/Yapily/StartAuthFlow'
export const YapilyStartAuthEmbeddedFlow = '/Yapily/StartAuthEmbeddedFlow'
export const YapilyUpdateAuthEmbeddedFlowScaMethodChoise = '/Yapily/UpdateAuthEmbeddedFlowScaMethodChoise'
export const YapilyUpdateAuthEmbeddedFlowScaCode = '/Yapily/UpdateAuthEmbeddedFlowScaCode'
export const YapilyGetConsent = '/Yapily/GetConsent'
export const YapilyRevoca = '/Yapily/Revoca'
export const RaccoltaDatiDownloadMovimenti = '/RaccoltaDati/DownloadMovimenti'
export const RaccoltaDatiDownloadSaldo = '/RaccoltaDati/DownloadSaldo'
export const ConfigurazioneGetAccessoContiCorrenti = '/Configurazione/GetAccessoContiCorrenti'
export const YapilySearchLookup = '/Yapily/SearchLookup'
export const YapilyDeleteLookup = '/Yapily/DeleteLookup'
export const YapilySaveLookup = '/Yapily/SaveLookup'
export const YapilyImportYapilyLookup = '/Yapily/ImportYapilyLookup'
export const YapilyUpdateEmbeddedFlow = '/Yapily/UpdateEmbeddedFlow'
export const YapilyExportYapilyLookup = '/Yapily/ExportYapilyLookup'
export const YapilyConsensiTesto = '/Yapily/ConsensiTesto'

// Supporto
export const SupportoInviaRichiesta = '/Supporto/InviaRichiesta'
export const SupportoRenderSupporto = '/Supporto/RenderSupporto'
export const SupportoGetStaticFile = '/api/Supporto/GetStaticFile'

export const PianoPrevisionaleGetPianiPrevisionaliList = '/PianoPrevisionale/GetPianiPrevisionaliList'
export const PianoPrevisionaleGetPianoPrevisonaleDettagli = '/PianoPrevisionale/GetPianoPrevisonaleDettagli'
export const PianoPrevisionaleGetPianoPrevisonale = '/PianoPrevisionale/GetPianoPrevisonale'
export const PianoPrevisionaleCalcolaPianoProvvigionale = '/PianoPrevisionale/CalcolaPianoProvvigionale'

// Licenza
export const CompraLicenzaTenant = '/Licenza/CompraLicenzaTenant'
export const CompraLicenzaCliente = '/Licenza/CompraLicenzaCliente'
export const RenderLicenze = '/Licenza/RenderLicenze'
export const SearchLicenze = '/Licenza/SearchLicenze'
export const RenderLicenzaClienti = '/Licenza/RenderLicenzaClienti'
export const AssegnaLicenzaClienti = '/Licenza/AssegnaClienti'
export const LicenzaCercaClienti = '/Licenza/CercaClientiSenzaLicenza'
export const CheckLicenseByCustomer = '/Licenza/CheckLicenseByCustomer'
